export const CardTypes = {
	Tracking: 'tracking',
	Recipe: 'recipe',
	Slogan: 'slogan',
	Task: 'task',
	Tip: 'tip',
	Workout: 'workout',
	DynamicProduct: 'dynamicProduct', // via Migros API
	Recommendation: 'recommendation', // via Magnolia
};
